import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { FailResponse } from 'api/evisaAPI/dlAPI'

type State = { errorMessage?: string } & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.SEND_UPDATE_PASSWORD_VERIFY_ASYNC,
    Actions.SEND_UPDATE_PASSWORD_VERIFY_SUCCESS,
    Actions.SEND_UPDATE_PASSWORD_VERIFY_FAIL,
    {},
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.SEND_UPDATE_PASSWORD_VERIFY_ASYNC:
    case Actions.SEND_UPDATE_PASSWORD_VERIFY_SUCCESS: {
      return {
        ...state,
        ...action.status,
      }
    }

    case Actions.SEND_UPDATE_PASSWORD_VERIFY_FAIL: {
      return {
        ...state,
        ...action.status,
        errorMessage: action.payload?.error.message || '',
      }
    }
    default:
      return state
  }
}
